Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.docsModelConfig = void 0;
exports.docsModelConfig = {
  docs: {
    fields: {
      heading: {
        type: 'shortText'
      },
      slug: {
        initialContent: 'initial-docs-slug',
        type: 'shortText',
        required: true,
        typePostfix: 'Slug',
        unique: true
      },
      text: {
        required: true,
        type: 'richText'
      },
      parentDocs: {
        allowedComponents: ['docs'],
        expandFragmentRef: true,
        initialContent: undefined,
        type: 'singleComponent'
      },
      sortOrder: {
        type: 'shortText'
      }
    },
    modelVersion: '1.0.0',
    settings: {
      asFragment: true,
      asQuery: 'subPage'
    }
  },
  docsSection: {
    fields: {
      variation: {
        items: ['docs'],
        type: 'dropdown'
      },
      eventId: {
        type: 'shortText',
        initialContent: 'initial-content-for-docs-section-event-id',
        typePostfix: 'Slug',
        helpText: 'Example: my-event-id',
        unique: true
      }
    },
    modelVersion: '1.0.0',
    settings: {
      asBoilerplate: false,
      asFragment: true,
      asPageSection: true
    }
  }
};